import * as React from "react";
const SvgFiRrBookFont = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M17 0H7C4.24 0 2 2.24 2 5v15c0 2.21 1.79 4 4 4h11c2.76 0 5-2.24 5-5V5c0-2.76-2.24-5-5-5m3 5v11H8V2h9c1.65 0 3 1.35 3 3M6 2.18V16c-.73 0-1.41.21-2 .56V5c0-1.3.84-2.4 2-2.82M17 22H6c-1.1 0-2-.9-2-2s.9-2 2-2h14v1c0 1.65-1.35 3-3 3m-6.21-8c.42 0 .8-.27.94-.66l.48-1.34h3.59l.48 1.34c.14.4.52.66.94.66.69 0 1.17-.68.94-1.34l-2.74-7.69c-.22-.6-.77-.99-1.41-.99s-1.19.39-1.41 1l-2.74 7.69c-.23.65.25 1.34.94 1.34zm4.3-4h-2.16l1.08-3.03z"
    />
  </svg>
);
export default SvgFiRrBookFont;
